import type { Action, MessageId, MessageState } from "@mailhand/core/schemas";
import type { ApiClient } from "../../api/client.js";
import { type BulkOutcome, overrideMessages } from "./bulkOverride.js";

export const DISMISSED_TOAST = "Dismissed.";

/** A member dismisses only a message that waits for them. */
export function canDismiss(state: MessageState): boolean {
  return state === "held" || state === "waiting";
}

function ignoreAction(actions: readonly Action[]): Action {
  const ignore = actions.find((action) => action.type === "ignore");
  if (ignore === undefined) throw new Error("This tenant has no Ignore action.");
  return ignore;
}

/** Dismiss: an override to the tenant's Ignore action that adds no example. */
export async function dismissMessage(api: ApiClient, actions: readonly Action[], messageId: string): Promise<void> {
  await api.call("messageOverride", { params: { id: messageId }, body: { actionId: ignoreAction(actions).id, inputs: {}, needsApproval: false, addExample: false } });
}

/** A bulk override to Ignore adds no example, so it is a dismiss. */
export async function dismissMessages(api: ApiClient, actions: readonly Action[], messageIds: readonly MessageId[]): Promise<BulkOutcome[]> {
  return overrideMessages(api, messageIds, ignoreAction(actions).id, false);
}
